/** @jsx jsx */
import { css } from "@emotion/react";

export const OndeEstamosStyles = css` 
  background-color: #FFFFFF;
  padding: 120px 0px;
  overflow: clip;
  scroll-margin-top: 70px;
  
  @media only screen and (max-width: 600px) {
    padding: 60px 0; 
    .form-sec {
      margin-top: 0px !important;
    }
  }

  .title-sec {
    margin-bottom: 56px;
    
  }

  .form-sec {
    margin-top: 80px;
    scroll-margin-top: 70px;
    img {
      width: 100%;
      border-radius: 56px;
    }
    .form-div {
      align-items: center;
      flex-direction: column;
      display: flex;
      justify-content: flex-start;
      height: 556px;
      border-radius: 16px;
      @media (max-width: 768px) {
        margin-bottom: 32px;
      }

      h1 {
        color:  #375F92;
        text-align: center;
        font-family: Montserrat;
        font-size: 40px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%;
        letter-spacing: -0.8px;
        margin-bottom: 32px;
      }
    }
    form {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 410px;
    gap: 8px;
    border-radius: 16px;
    .text_input_containe {
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 100%;
    }
    .text-label {
      color: #686868;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 38px;
      margin-bottom: 0px;
    }
    .text_input {
      background-color: #FFFFFF;
      border-radius: 8px;
      border: 1px solid #3C3C3C;
      font-family: Montserrat;
      padding: 5.8px 16px;
      width: 100%;
      font-size: 16px;
      font-weight: 600;
      /* margin-bottom: 8px; */
      &::placeholder {
        color: #686868;
        font-family: Montserrat;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 38px;
      }
    }
    .form-info {
      color: #686868;
      font-family: Montserrat;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-bottom: 24px;
    }
    .form-checbox {
      border: none;
      color: #3C3C3C;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      input {
        margin-right: 16px;
      }
    }
  }

  }

  h2 {
    color: #3C3C3C;
    font-family: Montserrat;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    span {
      color: #F26F33;
      font-weight: 600;
    }
  }

  p {
    color: #686868;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 0px;
  }
  
  .img {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 120px;
  }
`